// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vzDd","select":"styles_select__yzE4W"};